import React, { useState, useRef, useEffect } from "react";
import { ArrowDropDown } from "@mui/icons-material";

const CustomDropdown = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  className = "",
  required = false,
  isList = false,
  showBorder = true,
  disabled = false,
  valueColor = "",
  ulHeight,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = () => {
    if (disabled) return;

    // Calculate position synchronously to prevent jerk on first open
    if (!isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: "absolute",
        top: rect.height + 4, // below trigger
        left: 0,
        width: "100%",
        zIndex: 1000,
      });
    }

    setIsOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    if (isList) onChange(option);
    else onChange(option.value);
    setIsOpen(false);
  };

  return (
    <div className={`relative w-full ${className}`}>
      {label && (
        <label className="fs-14 font-semibold block mb-2">
          {label} <span className="color-red">{required && "*"}</span>
        </label>
      )}

      <div
        ref={triggerRef}
        className={`relative fs-14 w-full px-2 py-1.5 flex items-center justify-between transition-all ${
          showBorder ? "border br-10 shadow-md" : ""
        } ${
          disabled
            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
            : "bg-white cursor-pointer"
        } ${valueColor}`}
        onClick={handleToggle}
      >
        <span>
          {value
            ? options?.find((o) => o?.value === value)?.label
            : placeholder || "-Select-"}
        </span>
        <ArrowDropDown
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </div>

      {isOpen && (
        <ul
          ref={dropdownRef}
          style={dropdownStyle}
          className={`bg-white border br-10 shadow-lg fs-14 mt-1 max-h-60 overflow-auto ${
            ulHeight || ""
          }`}
        >
          {options?.map((option) => (
            <li
              key={option.value}
              className="p-2 cursor-pointer hover:bg-gray-100"
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(option);
              }}
            >
              {isList ? option : option?.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
